export { default } from './contacts-data';
